<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>秒杀活动</el-breadcrumb-item>
            <el-breadcrumb-item>{{$route.query.id ? '编辑秒杀活动' : '添加秒杀活动'}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box">
                <Card :bordered="false" dis-hover class="ivu-mt">
                    <Row type="flex" class="mt30 acea-row row-middle row-center">
                        <Col span="20">
                            <Steps :current="current">
                                <Step title="选择秒杀商品"></Step>
                                <Step title="填写基础信息"></Step>
                            </Steps>
                        </Col>
                        <Col span="23">
                            <Form class="form mt30" ref="formValidate" :rules="ruleValidate" :model="formValidate"  @on-validate="validate"
                                  :label-width="labelWidth" :label-position="labelPosition" @submit.native.prevent>
                                <FormItem label="选择商品：" prop="image_input" v-show="current === 0">
                                    <div class="picBox" @click="changeGoods">
                                        <div class="pictrue" v-if="goods">
                                            <img v-lazy="goods.product_pic_main">
                                        </div>
                                        <div class="upLoad acea-row row-center-wrapper" v-else>
                                            <Icon type="ios-camera-outline" size="26" class="iconfonts"/>
                                        </div>
                                    </div>
                                </FormItem>
                                <Row v-show="current === 1" type="flex">
                                    <Col span="24">
                                        <FormItem label="" prop="" v-if="goods">
                                            <el-table
                                                    :data="[goods]"
                                                    style="width: 100%">
                                                <el-table-column
                                                        prop="goods_id"
                                                        width="80"
                                                        label="商品ID">
                                                </el-table-column>
                                                <el-table-column
                                                        width="80"
                                                        label="商品图">
                                                    <template slot-scope="{ row, index }">
                                                        <viewer>
                                                            <div class="tabBox_img">
                                                                <img v-lazy="row.product_pic_main" />
                                                            </div>
                                                        </viewer>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        width="300"
                                                        prop="name"
                                                        label="商品名称">
                                                </el-table-column>
                                                <el-table-column
                                                        width="80"
                                                        prop="stock_total"
                                                        label="库存总量">
                                                </el-table-column>
                                                <el-table-column
                                                    min-width="200"
                                                    label="来源">
                                                    <template slot-scope="{ row, index }">
                                                        <div v-if="row.in_store">
                                                            自有商品
                                                        </div>
                                                        <div v-else>
                                                            <div>供应商商品</div>
                                                            <div style="margin-top: 10px">加价：<span style="color: red;">{{row.price}}</span></div>
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </FormItem>
                                    </Col>
                                    <Col span="24">
                                        <FormItem label="活动时间：" prop="section_time">
                                            <div class="acea-row row-middle">
                                                <DatePicker :editable="false" type="datetimerange" format="yyyy/MM/dd" placeholder="请选择活动时间"
                                                            @on-change="onchangeTime" class="perW30" :value="formValidate.section_time" v-model="formValidate.section_time" :disabled="$route.query.id ? true : false"></DatePicker>
                                                <div class="ml10 ivu-form-item-content">设置活动开启结束时间，用户可以在设置时间内发起参与秒杀</div>
                                            </div>
                                            <div class="warn ivu-form-item-content">为保证活动时间的唯一性，添加活动后，活动时间不能修改！</div>
                                        </FormItem>
                                    </Col>
                                    <Col span="24">
                                        <FormItem label="活动场次：" prop="time_id">
                                            <Checkbox-group v-model="formValidate.time_id">
                                                <Checkbox :label="'' + index" v-for="(item, index) in 24">
                                                    <span>{{(index < 10 ? '0' : '') +  index + ':00'}}</span>
                                                </Checkbox>
                                            </Checkbox-group>
                                        </FormItem>
                                    </Col>
                                    <Col span="24">
                                        <FormItem label="限购数量：" prop="limit_num" label-for="limit_num">
                                            <div class="acea-row row-middle">
                                                <InputNumber  placeholder="" element-id="limit_num" :min="0" :precision="0" v-model="formValidate.limit_num" class="perW20"/>
                                            </div>
                                            <div class="ivu-form-item-content grey">注：每人限制购买的数量，如果填写0则不限购</div>
                                        </FormItem>
                                    </Col>
                                    <Col span="24">
                                        <FormItem label="初始销量：" prop="initial_sales" label-for="initial_sales">
                                            <div class="acea-row row-middle">
                                                <InputNumber  placeholder="" element-id="initial_sales" :min="0" :precision="0" v-model="formValidate.initial_sales" class="perW20"/>
                                            </div>
                                            <div class="ivu-form-item-content grey">用户端显示的销量 = 初始销量 + 实际销量</div>
                                        </FormItem>
                                    </Col>
                                    <Col span="24">
                                        <FormItem label="活动状态：" prop="status" label-for="status">
                                            <RadioGroup element-id="status"  v-model="formValidate.status">
                                                <Radio :label="1" class="radio">开启</Radio>
                                                <Radio :label="0">关闭</Radio>
                                            </RadioGroup>
                                        </FormItem>
                                    </Col>
                                    <Col span="24" v-if="goods.in_store == 0">
                                        <FormItem label="秒杀库存：" prop="seckill_stock" label-for="seckill_stock">
                                            <div class="acea-row row-middle">
                                                <InputNumber  placeholder="" element-id="seckill_stock" :min="0" :precision="0" v-model="formValidate.seckill_stock" class="perW20"/>
                                            </div>
                                            <div class="ivu-form-item-content grey"></div>
                                        </FormItem>
                                        <FormItem label="秒杀加价：" prop="seckill_price" label-for="seckill_price">
                                            <div class="acea-row row-middle">
                                                <InputNumber  placeholder="" element-id="seckill_price" :min="0" :precision="0" v-model="formValidate.seckill_price" class="perW20"/>
                                            </div>
                                            <div class="ivu-form-item-content grey">供应商品，设置秒杀加价</div>
                                        </FormItem>
                                    </Col>
                                    <Col span="24" v-else>
                                        <FormItem label="规格选择：">
                                            <Table
                                                    ref="selection"
                                                    :data="specsData"
                                                    :columns="columns"
                                                    @on-selection-change="onSelectTab"
                                                    border>
                                                <template slot-scope="{ row, index }" slot="sku_name">
                                                    <span v-if="row.sku_name">
                                                        {{row.sku_name}}
                                                    </span>
                                                </template>
                                            </Table>
                                        </FormItem>
                                    </Col>
                                    <Col span="24">
                                        <FormItem label="排序：" prop="sort" label-for="sort">
                                            <InputNumber v-model="formValidate.sort"></InputNumber>
                                            <div class="ml10 grey">数字越小越靠前</div>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <FormItem>
                                    <Button class="submission mr15" @click="step" v-show="current !== 0" :disabled="$route.query.id&&$route.query.id != 0&&current===1">上一步</Button>
                                    <Button type="primary" :disabled="submitOpen && current === 2" class="submission" @click="next('formValidate')" v-text="current===1?'提交':'下一步'"></Button>
                                </FormItem>
                                <Spin size="large" fix v-if="spinShow"></Spin>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </div>
        </div>
        <!-- 选择商品-->
        <Modal v-model="modals" title="商品列表" footerHide  class="paymentFooter" scrollable width="900" @on-cancel="cancel">
            <goods-list ref="goodslist"  @getProductId="getProductId"></goods-list>
        </Modal>
    </div>
</template>

<script>
    import goodsList from '@/components/goodsList/index';
    import second from "./second.vue";
    import { formatDate } from "@/utils/validate";

    export default {
        name: "add",
        components: { second, goodsList },
        computed: {
            labelWidth () {
                return 135;
            },
            labelPosition () {
                return 'right';
            }
        },
        data () {
            return {
                isLoad: false,
                submitOpen: false,
                spinShow: false,
                isChoice: '',
                current: 0,
                modals: false,
                modal_loading: false,
                images: [],
                goods: false,
                columns: [
                    {
                        title: "规格",
                        align: 'center',
                        slot: "sku_name",
                        width: 120,
                    },
                    {
                        title: "原价",
                        align: 'center',
                        key: "price",
                        minWidth: 150,
                    },
                    {
                        title: "秒杀价",
                        align: 'center',
                        minWidth: 150,
                        render: (h, params) => {
                            return h('div', [
                                h('InputNumber', {
                                    props: {
                                        min: 0,
                                        value: params.row.seckill_price
                                    },
                                    on: {
                                        'on-change': e => {
                                            params.row.seckill_price = e;
                                            this.specsData[params.index] = params.row;
                                        }
                                    }
                                })
                            ])
                        }
                    },
                    {
                        title: "库存",
                        align: 'center',
                        key: "stock",
                    },
                    {
                        title: "秒杀库存",
                        align: 'center',
                        slot: "seckill_stock",
                        minWidth: 100,
                        render: (h, params) => {
                            return h('div', [
                                h('InputNumber', {
                                    props: {
                                        min: 0,
                                        value: params.row.seckill_stock
                                    },
                                    on: {
                                        'on-change': e => {
                                            params.row.seckill_stock = e;
                                            this.specsData[params.index] = params.row;
                                        }
                                    }
                                })
                            ])
                        }
                    },
                ],
                specsData: [],
                formValidate: {
                    section_time: [
                    ],
                    time_id: [],
                    goods_id: 0,
                    initial_sales: 0,
                    status: 1,
                    limit_num: 0,
                    sort: 100,
                    seckill_price: 0,
                    seckill_stock: 0
                },
                ruleValidate: {
                    section_time: [
                        { required: true, type: 'array', message: '请选择活动时间', trigger: 'change' }
                    ],
                    time_id: [
                        { required: true, type: 'array', message: '请选择活动场次'}
                    ],
                    limit_num: [
                        { required: true, type: 'number', message: '请输入限购数量'}
                    ],
                    initial_sales: [
                        { required: true, type: 'number', message: '请输入初始销量'}
                    ],
                },
                selectionList: [],
                picTit: '',
                tableIndex: 0,
                copy: 0,
                formSelection: [],
            }
        },
        mounted () {

            if (this.$route.query.id !== '0' && this.$route.query.id) {
                // this.copy = this.$route.params.copy;
                this.current = 1;
                this.getInfo();
            }
        },
        methods: {
            // 全选
            onSelectTab(selection) {
                this.selectionList = selection
            },
            // 商品id
            getProductId (row) {
                var _this = this
                this.modal_loading = false;
                this.modals = false;
                this.goods = row
                setTimeout(() => {
                    _this.formValidate.goods_id = row.goods_id
                    _this.$forceUpdate()
                    this.goodsAttrs(row);
                }, 500);
            },
            // 秒杀规格；
            goodsAttrs (row) {
                let that = this;
                this.axios.post('store/goods/detail', {
                    id: row.goods_id
                }).then(res => {
                    let data = res.data.detail;

                    var specsData = []
                    data.sku.forEach(function (item) {
                        specsData.push({
                            unique: item.unique,
                            stock: item.stock,
                            sku_name: item.sku_name,
                            price: item.price,
                            seckill_price: 0,
                            seckill_stock: 0
                        })
                    })
                    that.specsData = specsData
                }).catch(res => {
                    that.$Message.error(res.msg);
                })
            },
            cancel () {
                this.modals = false;
            },
            // 移动
            handleDragStart (e, item) {
                this.dragging = item;
            },
            handleDragEnd (e, item) {
                this.dragging = null
            },
            // 首先把div变成可以放置的元素，即重写dragenter/dragover
            handleDragOver (e) {
                e.dataTransfer.dropEffect = 'move'
            },
            handleDragEnter (e, item) {
                e.dataTransfer.effectAllowed = 'move'
                if (item === this.dragging) {
                    return
                }
                const newItems = [...this.formValidate.images]
                const src = newItems.indexOf(this.dragging)
                const dst = newItems.indexOf(item)
                newItems.splice(dst, 0, ...newItems.splice(src, 1))
                this.formValidate.images = newItems;
            },
            // 具体日期
            onchangeTime (e) {
                this.formValidate.section_time = e;
            },
            // 详情
            getInfo () {
                this.spinShow = true;
                this.axios.post('store/app.seckill.active/detail', {
                    active_id: this.$route.query.id
                }).then(async res => {
                    this.spinShow = false;
                    if (res.code == 1) {
                        var model = res.data.model
                        this.formValidate = {
                            section_time: [
                                formatDate(new Date(model.start_time * 1000), "yyyy/MM/dd"),
                                formatDate(new Date(model.end_time * 1000), "yyyy/MM/dd")
                            ],
                            time_id: model.time_id,
                            limit_num: model.limit_num,
                            godos_id: model.goods_id,
                            initial_sales: model.initial_sales,
                            seckill_price: model.seckill_price,
                            seckill_stock: model.seckill_stock,
                            status: model.status,
                            sort: model.sort
                        }

                        var skuList = model.skuList

                        this.goods = res.data.goods
                        let data = res.data.goods;
                        var specsData = []
                        data.sku.forEach(function (item) {

                            var spec = {
                                unique: item.unique,
                                stock: item.stock,
                                sku_name: item.sku_name,
                                price: item.price,
                                seckill_price: 0,
                                seckill_stock: 0
                            }
                            var sku = skuList.find(function (value) {
                                return value.unique == item.unique
                            })
                            if (sku) {
                                spec.seckill_price = parseFloat(sku.seckill_price)
                                spec.seckill_stock = sku.seckill_stock
                            }
                            specsData.push(spec)
                        })
                        console.log(specsData)
                        this.specsData = specsData
                    }
                }).catch(res => {
                    this.spinShow = false;
                    this.$Message.error(res.msg);
                })
            },
            // 下一步
            next (name) {
                var _this = this
                if (this.current === 1) {
                    this.$refs[name].validate((valid) => {
                        if (valid) {
                            if (this.goods.in_store) {
                                var flag = true
                                this.specsData.forEach(function (item) {
                                    if (item.seckill_price <= 0) {
                                        flag = false
                                        return _this.$Message.error('秒杀底价必须大于0');
                                    }
                                    if (item.seckill_stock > item.stock) {
                                        flag = false
                                        return _this.$Message.error('秒杀限量不能超过规格库存');
                                    }
                                    if (item.seckill_price > item.price) {
                                        flag = false
                                        return _this.$Message.error('秒杀底价必须小于原价');
                                    }
                                })

                                if (!flag) {
                                    return false;
                                }

                                if (this.copy == 1) this.formValidate.copy = 1;
                                this.formValidate.sku = JSON.parse(JSON.stringify(this.specsData))
                            }

                            this.submitOpen = true;
                            if (this.$route.query.id) {
                                this.axios.post('store/app.seckill.active/edit',{
                                    form: this.formValidate,
                                    active_id: this.$route.query.id
                                }).then(async res => {
                                    this.submitOpen = false;
                                    if (res.code == 1) {
                                        this.$Message.success(res.msg);
                                        setTimeout(() => {
                                            this.$router.push({ path: '/app/seckill/list.html' });
                                        }, 500);
                                    } else {
                                        this.$Message.error(res.msg);
                                    }
                                }).catch(res => {

                                })
                            } else {
                                this.axios.post('store/app.seckill.active/add',{
                                    form: this.formValidate
                                }).then(async res => {
                                    this.submitOpen = false;
                                    if (res.code == 1) {
                                        this.$Message.success(res.msg);
                                        setTimeout(() => {
                                            this.$router.push({ path: '/app/seckill/list.html' });
                                        }, 500);
                                    } else {
                                        this.$Message.error(res.msg);
                                    }
                                }).catch(res => {

                                })
                            }

                        } else {
                            return false;
                        }
                    })
                } else {
                    if (this.formValidate.peoples == 1) {
                        return this.$Message.error('秒杀人数必须大于1')
                    }
                    if (this.formValidate.id && parseInt(this.formValidate.status) === 0) {
                        return this.$Modal.confirm({
                            title: '检测到您要下架该秒杀商品',
                            content: '下架将会删除前台用户已砍的所有记录，所有用户将重新发起秒杀,您确定要这样操作吗？',
                            okText: '我想好了，确定要下架',
                            cancelText: '取消下架，活动状态改为开启',
                            onOk: () => {
                                this.current += 1;
                            },
                            onCancel: () => {
                                this.formValidate.status = 1;
                                this.current += 1;
                            }
                        });
                    }
                    if (!this.formValidate.goods_id) {
                        return this.$Message.warning('请选择商品');
                    }
                    this.current += 1;
                }
            },
            // 上一步
            step () {
                this.current--;
            },
            // 选择商品
            changeGoods () {
                this.modals = true;
                this.$refs.goodslist.getList();
                this.$refs.goodslist.goodsCategory();
            },
            // 表单验证
            validate (prop, status, error) {
                if (status === false) {
                    this.$Message.error(error);
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .tabBox_img {
        width: 36px;
        height: 36px;
        border-radius: 4px;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
        }
    }
</style>
